import { put } from "../api/client";
import { onApiError } from "../error";

/**
 * @param {string} imei 
 * @param {number} days 
 * @returns {Promise<Fencealarm2>}
 */
export async function putFa2Trial(imei, days) {
    const res = await put(`/fencealarm2s/${imei}/trial`, {
        body: JSON.stringify({
            Days: days
        })
    })
    if (!res.ok) throw onApiError(res)
    return res.json()
}